import { Controller } from "@hotwired/stimulus";

const ACE_MODE_MAP = { stylesheet: "css", javascript: "javascript" };

export default class extends Controller {
  static targets = [
    "componentNameInput",
    "kindInput",
    "wrapperCheckboxFrame",
    "componentNameFrame",
  ];
  connect() {}

  refresh() {
    const kind = this.hasKindInputTarget
      ? encodeURIComponent(this.kindInputTarget.value)
      : "";
    const componentName = this.hasComponentNameInputTarget
      ? encodeURIComponent(this.componentNameInputTarget.value)
      : "";
    const src = `${window.location.href}${window.location.href.includes("?") ? "&" : "?"}kind=${kind}&component_name=${componentName}`;
    this.wrapperCheckboxFrameTarget.src = src;
    this.componentNameFrameTarget.src = src;

    const aceEditor = this.element.querySelector(
      "[data-controller='ace-editor']",
    );
    if (aceEditor) {
      aceEditor.dataset.aceEditorModeValue =
        ACE_MODE_MAP[this.kindInputTarget.value] || "html";
    }
  }
}
